export default __webpack_public_path__ + "static/media/MenuIcon.61183186.svg";